import React from "react";
import "./Header.css";
import Navbar from '../Navbar/Navbar'
const Header = () => {
  return (
    <>
      <div className="container-fluid header px-0  mb-5">
        <Navbar></Navbar>
      </div>
    </>
  );
};

export default Header;
